import { Component } from '@angular/core';
import { OthersService } from "./shared/services/other-services/others.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private others: OthersService,) {
  }

  title = 'thunder-bolt-app';
  makeHttpCall() {
    this.others.getSmsLeft().subscribe(res => {
      // console.log(res)
    })
  }
  updateME(): any {
    this.title = 'Code 11 class';
  }
}
